import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/wpforms': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 75.2v361.7c0 24.3-19 43.2-43.2 43.2h-361.6c-23.9-0.1-43.2-18.7-43.2-43.3v-361.6c0-24.1 18.8-43.2 43.2-43.2h361.7c24 0 43.1 18.8 43.1 43.2zM410.7 436.8v-361.6c0-3-2.6-5.8-5.8-5.8h-9.3l-110.3 74.6-61.3-49.9-61.2 49.9-110.3-74.7h-9.3c-3.2 0-5.8 2.8-5.8 5.8v361.7c0 3 2.6 5.8 5.8 5.8h361.7c3.2 0.1 5.8-2.7 5.8-5.8zM150.2 186v37h-73.5v-37h73.5zM150.2 260.4v37.3h-73.5v-37.3h73.5zM161.3 113.1l54-43.7h-118.5zM371.3 186v37h-196v-37h196zM371.3 260.4v37.3h-196v-37.3h196zM286.7 113.1l64.5-43.7h-118.4zM371.3 335v37.3h-99.4v-37.3h99.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/wpforms.js
// module id = 1103
// module chunks = 0